export const logined = state => {
  return state.account.logined
}

export const loginedToken = state => {
  return state.account.token
}

export const loginedUserId = state => {
  return state.account.userId
}

export const loginedName = state => {
  return state.account.name
}

export const loginedUserType = state => {
  return state.account.userType
}

export const tagsList = state => {
  return state.tagsList.list
}

export const menuList = state => {
  return state.menuList.list
}

export const cachePage = state => {
  return state.page.cachePage
}

export const currentPath = state => {
  return state.page.currentPath
}

export const currentPageName = state => {
  return state.page.currentPageName
}

export const pageOpenedList = state => {
  return state.page.pageOpenedList
}

export const openedSubmenu = state => {
  return state.openedSubmenu.list
}

export const settings = state => {
  return state.settings
}
